import { render, staticRenderFns } from "./ModalNewFolder.vue?vue&type=template&id=45bf9ee2&scoped=true&"
import script from "./ModalNewFolder.vue?vue&type=script&lang=js&"
export * from "./ModalNewFolder.vue?vue&type=script&lang=js&"
import style0 from "./ModalNewFolder.vue?vue&type=style&index=0&id=45bf9ee2&prod&style=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf9ee2",
  null
  
)

export default component.exports